import Vue from 'vue'
import moment from 'moment'

const lang = localStorage.getItem('lang') ?? 'es_MX'

moment.locale(lang.substr(0, 2))

Vue.use(require('vue-moment'), {
	moment
})
